/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'approversEntityUser';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'globalEntityApproverUser';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'approverEntityUser';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'approversEntityUser';

/** Default list sort — matches legacy `useManageApproverEntityUser`. */
export const DEFAULT_ORDER_BY = 'dynamicEntity/displayName asc';
